import { DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, Validators } from "@angular/forms";
import { Flight } from "../../../../models/flight.model";
import { FlightEditLookups, TEXT_ONLY_ID } from "../../../form/flight-edit-lookups";

/** The airport the flight has, or a place it keeps only as text: either way the leg is required. */
function airportControl(id: number | null, place: string | null) {
    return new FormControl<number | null>(id ?? (place?.trim() ? TEXT_ONLY_ID : null), Validators.required);
}

export function legControls(flight: Flight, _lookups: FlightEditLookups) {
    return {
        departureId: airportControl(flight.departureId, flight.departurePlace),
        arrivalId: airportControl(flight.arrivalId, flight.arrivalPlace),
    };
}

// A ground run has one place: when the user changes it, the arrival takes the airport of the departure.
export function watchGroundRunLeg(departureId: FormControl<number | null>, arrivalId: FormControl<number | null>, destroyRef: DestroyRef): void {
    departureId.valueChanges.pipe(takeUntilDestroyed(destroyRef)).subscribe((value) => arrivalId.setValue(value));
}
